// extracted by mini-css-extract-plugin
export var cancelButton = "_pj-5";
export var content = "_pj-3";
export var createButton = "_pj-6";
export var drawerContainer = "_pj-0";
export var footer = "_pj-2";
export var header = "_pj-1";
export var orderFormColumn = "_pj-4";